import apiCall from "./apiCall";

export default async function getValidateOnboardingToken(token) {
    const URL = process.env.REACT_APP_API_URL+'/api/onboarding/validate/'+token;
    const data = await apiCall('GET', URL, {});
    return data;
}
